import SvgColor from "../../../components/svg-color";
import { getUserPermissions, getCurrentUser } from "src/utils/permissionsUtils";
import { withTenant } from "src/utils/withTenant";

const icon = (name, size = "medium") => {
  const sizeConfig = {
    small: { width: 0.6, height: 0.6 },
    medium: { width: 1, height: 1 },
  };

  return (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={sizeConfig[size]} />
  );
};

const { isSuperAdmin, isClient } = getUserPermissions();
const currentUser = getCurrentUser();
const userMenuItems = currentUser?.admin?.menuItems || [];

// Helper function to filter menu items based on client permissions
const filterForClient = (config) => {
  return isClient
    ? config.filter((item) => userMenuItems.includes(item.key))
    : config;
};

export const homeConfig = filterForClient([
  {
    key: "home",
    title: "Home",
    path: "/dashboard/home",
    icon: icon("home-outline"),
  },
]);

export const appConfig = filterForClient([
  {
    key: "users",
    title: "Users",
    path: "/dashboard/users",
    icon: icon("users", "small"),
  },
  ...(isSuperAdmin
    ? [
      {
        key: "admins",
        title: "Admins",
        path: "/dashboard/admins",
        icon: icon("lock-outline"),
      },
    ]
    : []),
  {
    key: "lobby",
    title: "Lobby",
    path: "/dashboard/lobby",
    icon: icon("layout-outline"),
  },
  {
    key: "home-components",
    title: "Home Components",
    path: "/dashboard/home-components",
    icon: icon("layout-outline"),
  },
  {
    key: "inbox",
    title: "Inbox",
    path: "/dashboard/inbox",
    icon: icon("notes", "small"),
  },
  {
    key: "promotions",
    title: "Promotions",
    path: "/dashboard/promotions",
    icon: icon("gift-outline"),
  },
  {
    key: "user-levels",
    title: "User Levels",
    path: "/dashboard/user-levels",
    icon: icon("king"),
  },
  {
    key: "settings",
    title: "Settings",
    path: "/dashboard/app-settings",
    icon: icon("settings-outline"),
  },
  {
    key: "tenants",
    title: "Tenants",
    path: "/dashboard/tenants",
    icon: icon("tenants"),
  },
  // {
  //   key: "teams",
  //   title: "Teams",
  //   path: "/dashboard/scoreables",
  //   icon: icon("union-teams"),
  // },
  {
    key: "competitions",
    title: "Competitions",
    path: "/dashboard/competitions",
    icon: icon("shield"),
  },
  {
    key: "pack-assets",
    title: "Pack Assets",
    path: "/dashboard/pack-assets",
    icon: icon("packs-icon"),
  },
]);

export const getContestConfig = (tenantId) => {
  return filterForClient([
    {
      key: "stage-periods",
      title: "Stages Periods",
      path: withTenant("/dashboard/stages-periods", tenantId),
      icon: icon("trophy"),
    },
    {
      key: "divisions",
      title: "Divisions",
      path: withTenant("/dashboard/divisions", tenantId),
      icon: icon("divisions"),
    },
    {
      key: "leaderboard",
      title: "Leaderboards",
      path: withTenant("/dashboard/leaderboard", tenantId),
      icon: icon("leaderboard"),
    },
    {
      key: "fixtures",
      title: "Fixtures",
      path: withTenant("/dashboard/fixtures", tenantId),
      icon: icon("scoring"),
    },
    {
      key: "teams",
      title: "Teams",
      path: withTenant("/dashboard/scoreables", tenantId),
      icon: icon("union-teams"),
    },
    {
      key: "scoring",
      title: "Scoring",
      path: withTenant("/dashboard/scoring", tenantId),
      icon: icon("registration"),
    },
    {
      key: "xp-rewards",
      title: "XP Rewards",
      path: withTenant("/dashboard/levels/settings", tenantId),
      icon: icon("rewards"),
    },
    {
      key: "seasons",
      title: "Seasons",
      path: withTenant("/dashboard/seasons", tenantId),
      icon: icon("season"),
    },
  ]);
};

export const getStoreConfig = (tenantId) => {
  return filterForClient([
    {
      key: "coins-spins-pass",
      title: "Coins/Spins/Pass",
      path: withTenant("/dashboard/coins-spins-pass", tenantId),
      icon: icon("coins-icon"),
    },
    {
      key: "coin-transactions",
      title: "Coin Transactions",
      path: withTenant("/dashboard/coin-transactions", tenantId),
      icon: icon("transactions"),
    },
    {
      key: "marketplace",
      title: "Coins Store",
      path: withTenant("/dashboard/marketplace", tenantId),
      icon: icon("shopping-cart-outline"),
    },
  ]);
};

export const getMarketplacePacksConfig = (tenantId) => {
  return filterForClient([
    {
      key: "packs-dashboard",
      title: "Packs Dashboard",
      path: withTenant("/dashboard/packs-dashboard", tenantId),
      icon: icon("packs-icon"),
    },
    {
      key: "marketplace",
      title: "Packs Marketplace",
      path: withTenant("/dashboard/marketplace-packs", tenantId),
      icon: icon("shopping-cart-outline"),
    },
  ]);
};

export const getAppComponentsConfig = (tenantId) => {
  return filterForClient([
    {
      key: "app-components",
      title: "App Components",
      path: withTenant("/dashboard/app-components", tenantId),
      icon: icon("settings-outline"),
    },
  ]);
};

export const getPrizeDrawConfig = (tenantId) => {
  return filterForClient([
    {
      key: "prize-draws",
      title: "Prize Draws",
      path: withTenant("/dashboard/prize-draws", tenantId),
      icon: icon("gift-outline"),
    },
    {
      key: "ticket-transactions",
      title: "Ticket Transactions",
      path: withTenant("/dashboard/ticket-transactions", tenantId),
      icon: icon("transactions"),
    },
  ]);
};

export const minigamesConfig = filterForClient([
  {
    key: "versus",
    title: "Versus",
    path: "/dashboard/versus",
    icon: icon("versus-icon"),
  },
  {
    key: "game-providers",
    title: "Game Providers",
    path: "/dashboard/game-providers",
    icon: icon("flash-outline"),
  },
]);

export const getChallengesConfig = (tenantId) => {
  return filterForClient([
    {
      key: "challenges-setups",
      title: "Setups",
      path: withTenant("/dashboard/challenge-setups", tenantId),
      icon: icon("club-challenges"),
    },
    {
      key: "challenges",
      title: "Challenges",
      path: withTenant("/dashboard/challenges", tenantId),
      icon: icon("all-club-challenges"),
    },
  ]);
};